const { REACT_APP_API_URL, REACT_APP_DEBUG_MODE } = process.env;

export default REACT_APP_DEBUG_MODE === "true"
	? "http://127.0.0.1:3002/api/v1"
	: REACT_APP_API_URL;
